import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import settings from '/@/core/settings';
import styles from './styles.module.css';

@autobind
export default class Spinner extends Component {
    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
    };

    static defaultProps = {
        className: '',
        style: {},
    };

    render() {
        return (
            <div className={classNames(styles.root, this.props.className)} style={this.props.style}>
                <div className={classNames(styles.dot1, styles[settings.app.theme])} />
                <div className={classNames(styles.dot2, styles[settings.app.theme])} />
            </div>
        );
    }
}
